import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const Newest = () => {
  return <ListStory page={1} type="newstories" />;
};

export default Newest;
